import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TireTypeForm, TireTypeListMeta, TireTypeRow } from "../types";
import { initialTireTypeForm, initialState } from "./initialState";

export const sliceKey = "tireTypeState";

type TireTypeListSuccessPayload = {
  data: TireTypeRow[];
  meta: TireTypeListMeta;
};

const tireTypeSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getTireTypeList(state) {
      state.loading = true;
      state.error = null;
      state.page = 1;
    },

    getTireTypeListSuccess(
      state,
      action: PayloadAction<TireTypeListSuccessPayload>
    ) {
      state.loading = false;
      state.list = action.payload.data;
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getTireTypeListError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    getNextPageItems(state) {
      if (state.loading || state.meta.currentPage >= state.meta.totalPages) {
        return;
      }
      state.loading = true;
      state.error = null;
      state.page = state.meta.currentPage + 1;
    },

    getNextPageItemsSuccess(
      state,
      action: PayloadAction<TireTypeListSuccessPayload>
    ) {
      state.loading = false;
      state.list = state.list.concat(action.payload.data);
      state.meta = action.payload.meta;
      state.page = action.payload.meta.currentPage;
      state.error = null;
    },

    getNextPageItemsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
      state.error = null;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
      state.error = null;
      state.form = initialTireTypeForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof TireTypeForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    resetForm(state) {
      state.form = initialTireTypeForm;
    },

    addTireType(state) {
      state.saving = true;
      state.error = null;
    },

    addTireTypeSuccess(state) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.form = initialTireTypeForm;
      state.error = null;
    },

    addTireTypeError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { actions: tireTypeActions, reducer } = tireTypeSlice;
